// extracted by mini-css-extract-plugin
module.exports = {"container":"wv","hide":"ww","content":"wx","close":"wy","closeIcon":"wz","svgStyles":"wA"};